import { AuditOutlined, FileTextOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { CompanyInterface } from './company.interface'
import { getCompanySettingsInitialValues } from './helpers/get-company-settings-initial-values'
import { CompanyValidationSchema } from './validators/company-validation-schema'
import { useFormik } from '../../../common/hooks/formik'
import { PureButton } from '../../../common/ui/pure-button/pure-button'
import { PureInput } from '../../../common/ui/pure-input/pure-input'
import { PureTextArea } from '../../../common/ui/pure-text-area/pure-text-area'
import { CompanyData } from '../../../entities/dadata/types/dadata.types'
import { useCheckOrganization } from '../../../entities/organizations/hooks/organization.hooks'
import { useUserStore } from '../../../entities/user/stores/user.store'
import { SearchCompany } from '../../shared/components/search-company/search-company'

export const CompanyPage = () => {
  const { t } = useTranslation()

  const { mutateAsync: checkOrganization } = useCheckOrganization()
  const { user } = useUserStore()

  const handleSearchCompany = (company: CompanyData) => {
    formik.setValues({
      ...formik.values,
      companyName: company.value,
      companyInn: company.data.inn,
      companyOgrn: company.data.ogrn,
    })
  }

  const formik = useFormik<CompanyInterface>({
    initialValues: getCompanySettingsInitialValues({
      companyOgrn: user?.organization?.ogrn ?? null,
      companyInn: user?.organization?.inn ?? null,
      companyName: user?.organization?.name ?? null,
      text: null,
    }),
    validationSchema: CompanyValidationSchema(),
    enableReinitialize: true,
    onSubmit: () => {},
  })

  const handleSubmit = async () => {
    const err = await formik.validateForm()
    if (Object.values(err).length) {
      return
    }
    const isOrganizationExists = await checkOrganization(formik.values.companyOgrn || '')
    if (isOrganizationExists.exists) {
      toast.error(t('auth.register.errors.companyExists'))

      return
    }
  }

  return (
    <div>
      <PureTextArea {...formik.getFieldProps('text')} />
      <SearchCompany
        colClass="col-12 col-md-12 mb-4"
        initialValue={formik.values.companyName ?? undefined}
        label={t('auth.register.companySearch')}
        onChange={handleSearchCompany}
      />
      <div className="d-flex">
        <PureInput
          {...formik.getFieldProps('companyName')}
          colClass="col-12 col-md-6"
          error={formik.errors.companyName}
          icon={<AuditOutlined />}
          label={t('auth.register.companyName')}
          moduleStyle="mb-4"
          required
        />
        <PureInput
          {...formik.getFieldProps('companyInn')}
          colClass="col-12 col-md-6"
          error={formik.errors.companyInn}
          icon={<FileTextOutlined />}
          label={t('auth.register.companyInn')}
          moduleStyle="mb-4"
          required
        />
      </div>
      <div className="d-flex">
        <PureInput
          {...formik.getFieldProps('companyOgrn')}
          colClass="col-12 col-md-6"
          error={formik.errors.companyOgrn}
          icon={<FileTextOutlined />}
          label={t('auth.register.companyOgrn')}
          moduleStyle="mb-4"
          required
        />
      </div>
      <div className="d-flex justify-content-between mt-4">
        <div className="col-4 col-md-3">
          <PureButton
            onClick={handleSubmit}
            type="primary"
            block
          >
            {t('common.save')}
          </PureButton>
        </div>
      </div>
    </div>
  )
}
